import { useState } from "react";
import Loginimg from "../components/img/Login.svg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import api from "../api/axiosInstance";
import { useNavigate, useLocation } from "react-router-dom";

const OtpNew = () => {
  const location = useLocation(); // ✅ Define first
  const navigate = useNavigate();

  const loginType = location.state?.type || "";
  const loginValue = location.state?.value || "";
  const [loading, setLoading] = useState(false);
  const prefix = "+91";
  const handleInputFocus = (event) => {
    const input = event.target;
    // If cursor is before prefix, move it after prefix
    if (input.selectionStart < prefix.length) {
      input.setSelectionRange(prefix.length, prefix.length);
    }
  };

  const handleKeyDown = (event) => {
    const input = event.target;
    // Prevent backspace/delete if cursor at or before prefix length
    if (
      (event.key === "Backspace" || event.key === "Delete") &&
      input.selectionStart <= prefix.length
    ) {
      event.preventDefault();
    }
  };

  const handlePhoneChange = (value) => {
    // Always enforce prefix '+91'
    let val = value;
    if (!val.startsWith(prefix)) {
      const digits = val.replace(/\D/g, "");
      let phoneDigits = digits;
      if (digits.startsWith("91")) {
        phoneDigits = digits.slice(2);
      }
      phoneDigits = phoneDigits.slice(0, 10);
      val = prefix + phoneDigits;
    }
    setPhone(val);
    setOtpMessage("");
  };

  const [phone, setPhone] = useState(
    loginType === "phone" ? "91" + loginValue.slice(-10) : ""
  );

  const [email, setEmail] = useState(loginType === "email" ? loginValue : "");

  const [otpMessage, setOtpMessage] = useState("");
  const [otpMessageType, setOtpMessageType] = useState("");

  const handleSendOtp = async () => {
    setLoading(true);
    if (loginType === "phone") {
      const cleanedPhone = phone.replace(/\D/g, "");

      if (cleanedPhone.length < 11) {
        setOtpMessage("Phone not registered. Click SIGN UP to register.");
        setOtpMessageType("error");
        return;
      }

      const phoneNumber = cleanedPhone.slice(-10);
      const countryCode = "+" + cleanedPhone.slice(0, cleanedPhone.length - 10);

      try {
        const response = await api.post("api/v1/get-otp-for-login", {
          phone_number: phoneNumber,
          country_code: countryCode,
        });

        if (
          response.data.status === "success" &&
          response.data.response_code === 201
        ) {
          setOtpMessage("OTP sent successfully");
          setOtpMessageType("success");

          setTimeout(() => {
            navigate("/Otp", { state: { phoneNumber } });
          }, 1500);
        } else {
          setOtpMessage("Please enter your registered mobile number");
          setOtpMessageType("error");
        }
      } catch (error) {
        console.error("Error sending OTP:", error);
        setOtpMessage("Something went wrong. Please try again.");
        setOtpMessageType("error");
      } finally {
        setLoading(false); // Stop loading
      }
    }

    // ✅ Treat email login the same way — send email in `phone_number`
    else if (loginType === "email") {
      if (!email.includes("@")) {
        setOtpMessage("Please enter a valid email address");
        setOtpMessageType("error");
        return;
      }

      try {
        const response = await api.post("api/v1/get-otp-for-login", {
          phone_number: email, // email as phone_number
          country_code: "", // empty string for email
        });

        if (
          response.data.status === "success" &&
          response.data.response_code === 201
        ) {
          setOtpMessage("OTP sent to your email");
          setOtpMessageType("success");

          setTimeout(() => {
            navigate("/Otp", { state: { email } });
          }, 2000);
        } else {
          setOtpMessage("Email not registered. Click SIGN UP to register.");
          setOtpMessageType("error");
        }
      } catch (error) {
        console.error("Error sending OTP:", error);
        setOtpMessage("Something went wrong. Please try again.");
        setOtpMessageType("error");
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Left Content */}
      <div className="w-full lg:w-1/2 flex justify-center items-start mt-56">
        <div className="w-full">
          <h2 className="text-xl font-semibold text-center">
            {loginType && loginValue && (
              <>
                OTP will be sent to your{" "}
                {loginType === "phone" ? "phone" : "email"}:{" "}
                <span className="text-[#9061DB]">{loginValue}</span>
              </>
            )}
          </h2>

          <p className="text-center mb-6 font-inter text-sm text-black">
            We’ll send you a text verification code
          </p>

          <div className="flex flex-col items-center gap-2 mt-8">
            <div className="flex flex-col text-left">
              <label
                htmlFor="mobileNumber"
                className="text-sm text-inter text-black"
              >
                Enter your registered mobile number or email address
              </label>

              <div className="w-96 mt-2 mb-6">
                <>
                  <style>
                    {`
      .react-tel-input .selected-flag {
        width: 38px !important;
        height: 94% !important;
      }

      .react-tel-input .flag-dropdown {
        top: 4px !important;
        bottom: 0px !important;
        left: 4px !important;
      }
    `}
                  </style>
                  {loginType === "phone" ? (
                    <PhoneInput
                      country={"in"}
                      onlyCountries={["in"]}
                      disableDropdown={true}
                      enableSearch={false}
                      disableSearchIcon={true}
                      value={phone}
                      onChange={handlePhoneChange}
                      onFocus={handleInputFocus}
                      onKeyDown={handleKeyDown}
                      inputProps={{ name: "phone", required: true }}
                      inputStyle={{
                        width: "100%",
                        paddingLeft: "48px",
                        border: "2px solid #9061DB",
                        borderRadius: "0.375rem",
                        height: "40px",
                        backgroundColor: "transparent",
                        color: "#000",
                        fontFamily: "inherit",
                      }}
                      buttonStyle={{
                        border: "none",
                        backgroundColor: "transparent",
                        cursor: "default",
                      }}
                      containerStyle={{
                        width: "100%",
                      }}
                      dropdownStyle={{
                        display: "none",
                      }}
                    />
                  ) : (
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your registered email"
                      className="w-full px-4 py-2 border-2 border-[#9061DB] rounded-md bg-transparent text-black font-inter"
                    />
                  )}
                </>

                {otpMessage && (
                  <div className="flex flex-col items-center mt-1">
                    <p
                      className={`text-sm ${
                        otpMessageType === "success"
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {otpMessage}
                    </p>

                    {(otpMessage === "Phone not registered. Click SIGN UP to register." ||
                      otpMessage ===
                        "Please enter your registered mobile number" ||
                      otpMessage === "Email not registered. Click SIGN UP to register.") && (
                      <span
                        onClick={() => navigate("/SignUp")}
                        className="text-[#9367D7]  cursor-pointer font-semibold bg-gradient-to-r from-[#4C3A68] to-[#9061DB] text-white px-5 py-2 rounded-lg mt-2"
                      >
                        Sign up
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="font-inter flex justify-center items-center mt-8 text-sm">
            Didn’t get OTP?{" "}
            <span
              className="ml-1 font-semibold"
              style={{ color: "#9367D7", cursor: "pointer" }}
              onClick={handleSendOtp}
            >
              Resend code
            </span>
          </div>

          <div className="flex justify-center mt-8">
            <button
              type="submit"
              onClick={handleSendOtp}
              className="bg-gradient-to-r from-[#4C3A68] to-[#9061DB] text-white rounded-md hover:opacity-90 transition font-inter w-32 h-10 "
            >
              {loading ? "Sending..." : "Send"}
            </button>
          </div>
        </div>
      </div>

      {/* Right Content */}
      <div
        className="w-full lg:w-1/2 min-h-[300px] lg:min-h-screen bg-no-repeat bg-center bg-cover"
        style={{ backgroundImage: `url(${Loginimg})` }}
      ></div>
    </div>
  );
};

export default OtpNew;
